// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"748":"9cc5fe8b","942":"aa026a3b","6454":"9e962f7a","7001":"3814db06"}[chunkId] + ".chunk.css";
};